import { FC, ReactNode } from 'react'
import { isIOS, isMobileSafari } from 'react-device-detect'
import styled from 'styled-components'
import { Modal, TextLegacy } from '@/components/common'
import { NewCol } from '@/components/common/layouts/NewCol'
import { NewRow } from '@/components/common/layouts/NewRow'
import { ModalBaseProps } from '@/components/common/modals/ModalBase'

type ModalPolicyContent = {
  title: string
  content?: ReactNode
}

export type ModalPolicyData = {
  subContents?: ModalPolicyContent[]
} & ModalPolicyContent

type ModalPolicyProps<T> = {} & ModalBaseProps<T>

const ModalPolicy: FC<ModalPolicyProps<any>> = ({ useModalProps }) => {
  const policyData = useModalProps.data as ModalPolicyData

  return (
    <Modal
      useModalProps={useModalProps}
      buttonType="ACTION"
      okText="확인"
      onOk={() => {
        useModalProps.hideModal()

        if (isIOS || isMobileSafari) {
          const scrollBottom = document?.body?.scrollHeight || 10
          window.scrollTo({ top: scrollBottom - 10, behavior: 'smooth' })
        }
      }}
    >
      <ModalBody>
        <NewRow justify="center">
          <TitleCol>
            <TextLegacy size={{ xs: 16, md: 18 }} weight="bold">
              {policyData.title}
            </TextLegacy>
          </TitleCol>
        </NewRow>
        <NewRow>
          {useModalProps.visible && policyData.content && (
            <NewCol>
              <TextLegacy size={{ xs: 10, md: 12 }}>{policyData.content}</TextLegacy>
            </NewCol>
          )}
        </NewRow>
        {policyData.subContents?.map((subContent, index) => {
          return (
            <div key={index}>
              <NewRow>
                <SubTitleCol>
                  <TextLegacy size={{ xs: 14, md: 16 }}>{subContent.title}</TextLegacy>
                </SubTitleCol>
              </NewRow>
              <NewRow>
                <SubContentCol>
                  <SubContentBody>
                    <TextLegacy size={{ xs: 10, md: 12 }}>{subContent.content}</TextLegacy>
                  </SubContentBody>
                </SubContentCol>
              </NewRow>
            </div>
          )
        })}
      </ModalBody>
    </Modal>
  )
}

const ModalBody = styled.div`
  max-height: 500px;
  height: 60vh;
  overflow: hidden scroll;
`

const TitleCol = styled(NewCol)`
  text-align: center;
  margin-bottom: 12px;
`

const SubTitleCol = styled(NewCol)`
  text-align: center;
  margin-top: 12px;
`

const SubContentCol = styled(NewCol)`
  text-align: center;
  background: ${(props) => props.theme.color.gray50};
  border-radius: 3px;
  margin-top: 9px;
  margin-bottom: 8px;
`

const SubContentBody = styled.div`
  height: 190px;
  overflow: hidden scroll;
`

export default ModalPolicy
